<template>
  <div style="height: 80vh" class="d-flex justify-center align-center">
    <v-progress-circular
      :size="50"
      color="blue"
      indeterminate
    ></v-progress-circular>
  </div>
</template>
<script>

import baseapifactory from "../../../apis/apifactory";
import api from "../api";
export default {
  setup() {},
  data() {
    return {
      counternumber: 100,
      countDown: 0,
      
      isdecayalreaysave: 0,
    };
  },
  methods: {
    // step1
    saveAndSetStepParms() {
      this.call_api_checkdata();
     
    },
    call_api_checkdata() {
      //alert("call_api_checkdata");
      baseapifactory
        .api_get_project_data_instep1()
        .then((res) => {
          //alert(JSON.stringify(res));
          
          if (res.data.status != 402) {
           this.call_api_save_step3();
          }
          else{
             alert("Sorry Please set the project .");
              this.$router.push("/settingproject");

          }
        })
        .catch(function (error) {
          alert("call_api_save_step3" + error);
          // return false;
        });
    },
    // step3
    call_api_save_step3() {
      baseapifactory
        .api_save_step3()
        .then((res) => {
          ////alert(JSON.stringify(res));
          if (res != null) {
           this.call_api_save_step4();
          }
        })
        .catch(function (error) {
          alert("call_api_save_step3" + error);
          // return false;
        });
    },

    // step4
    call_api_save_step4() {
      baseapifactory
        .api_save_step4()
        .then((res) => {
          ////alert(JSON.stringify(res));
          if (res != null) {
           this.call_api_save_step5();
          }
        })
        .catch(function (error) {
          alert("call_api_save_step4 hhhhhh" + error);
          // return false;
        });
    },
    // step5
    call_api_save_step5() {
      baseapifactory
        .api_save_step5()
        .then((res) => {
          //alert(JSON.stringify(res));
          if (res != null) {
           this.call_save_vargrp_for_model();
          }
        })
        .catch(function (error) {
          alert("call_api_save_step5" + error);
          // return false;
        });
    },

    call_save_vargrp_for_model() {
      api
        .api_get_vargrp_for_model()
        .then((res) => {
          //alert(JSON.stringify(res));
          if (res != null) {
           this.$router.push("/modeldata");
          }
        })
        .catch(function (error) {
          alert("call_api_save_step5" + error);
          // return false;
        });
    },

    countDownTimer() {
      if (this.countDown > 0) {
        setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    countDownTimerIncrease() {
      setTimeout(() => {
        this.countDown += 1;
        this.countDownTimerIncrease();
      }, 1000);
    },
  },
  computed: {
    getcounter() {
      return this.counternumber + 1;
    },
  },
  created() {
    this.countDownTimerIncrease();
  },

  mounted() {
    //this.callworkflowsteps();
    this.saveAndSetStepParms();
  },
};
</script>
<style scoped>
.v-progress-circular {
  margin: 1rem;
}
</style>
